import React, { useEffect, useState } from 'react';

import styles from './ReopenCaseDialog.module.css';

import { getEnvironmentApiUrl } from '../../../services/General';

import useHttp from '../../../hooks/useHttp';
import { useToast } from '../../../hooks/useToast';
import { useTranslation } from 'react-i18next';

import CloseCaseInfo from '../CloseCaseInfo/CloseCaseInfo';
import InputSelect from '../../UI/InputSelect/InputSelect';
import CancelConfirmButtons from '../../UI/CancelConfirmButtons/CancelConfirmButtons';

import { Bed, Case } from '../../../interfaces/Patient';
import { OptionsSelect } from '../../../interfaces/Input';

interface Props {
    caso: Case;
    closeModal: () => void;
    updateCase: (body: Partial<Case>) => void
}

const ReopenCaseDialog: React.FC<Props> = ({ caso, closeModal, updateCase }) => {

    const { t } = useTranslation();
    const { error } = useToast();

    const { sendRequest: getAllAvailableBeds } = useHttp<Bed[]>();
    const { error: errorPost, sendRequest } = useHttp();

    const [selectedBed, setSelectedBed] = useState<string | null>(null);
    const [optionBeds, setOptionBeds] = useState<OptionsSelect[]>([]);

    useEffect(() => {
        getAllAvailableBeds({
            url: getEnvironmentApiUrl() + 'bed/all_available',
            method: 'POST',
            body: {
                filter: {},
                params: {}
            }
        }, (data) => {
            setOptionBeds(data.map(b => ({ id: b.id, name: b.name ?? '' })));
        });
    }, [getAllAvailableBeds]);

    const handleRepoenCase = (bedId: string) => {
        const followUp = caso.follow_ups?.[0];
        sendRequest({
            url: getEnvironmentApiUrl() + 'case/reopen_case',
            method: 'POST',
            body: {
                profile_id: followUp?.profile_id,
                bed_id: bedId,
                case_id: caso.id,
                is_home: true,
            }
        }, () => {
            updateCase({ end_date: null, closure_reason_id: null });
            closeModal();
        });
    };

    useEffect(() => {
        console.log(errorPost);
        if (!errorPost) return;
        error(errorPost);
    }, [error, errorPost]);

    const handleChangeBed = (bedOption: OptionsSelect) => {
        setSelectedBed(bedOption.id as string);
    };

    const handleConfirm = () => {
        const value = selectedBed;
        if (!value) return;
        handleRepoenCase(value);
    };

    return (
        <div className='dialog'>
            <CloseCaseInfo
                caso={caso}
                closureReason={null}
            />
            <p className={styles.selectBedLabel}>{t('select_bed_to_assign')}:</p>
            <InputSelect
                options={optionBeds}
                onChange={handleChangeBed}
                value={selectedBed ?? ''}
                label=''
                simpleStyles
                width={'100%'}
            />
            <CancelConfirmButtons
                onCancel={closeModal}
                onConfirm={handleConfirm}
            />
        </div>
    );
};

export default ReopenCaseDialog;